var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconUserFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.135 17.907c-.977-.406-2.185-.93-2.185-1.337v-2.617a5.914 5.914 0 002.3-4.65V5.813C18.25 2.616 15.662 0 12.5 0S6.75 2.616 6.75 5.814v3.488c0 1.804.862 3.605 2.3 4.651v2.617c0 .35-1.208.872-2.185 1.337C4.508 18.895 1 20.407 1 24.42V25h23v-.581c0-4.011-3.508-5.524-5.865-6.512z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default SvgCommonIconUserFilled;